export const defaultServiceStatusDefinition = {
  ACTIVE: "ACTIVE",
  RESTRICTED: "RESTRICTED",
  PAUSED: "PAUSED",
  QUOTA_EXCEEDED: "QUOTA_EXCEEDED"
}

export const defaultChatUiDefinition = {
  INPUT: "INPUT",
  RELATED_QUESTIONS: "RELATED_QUESTIONS",
  BOTTOM_SUGGESTIONS: "BOTTOM_SUGGESTIONS"
};

export const STATUS_CONFIG = {
  [defaultServiceStatusDefinition.ACTIVE]: {
    [defaultChatUiDefinition.INPUT]: false, // 下方對話input輸入框 & Submit 按鈕.
    [defaultChatUiDefinition.RELATED_QUESTIONS]: false, // 對話欄內問題按鈕.
    [defaultChatUiDefinition.BOTTOM_SUGGESTIONS]: false, // 底部問題按鈕.
    bannerText: ""
  },
  [defaultServiceStatusDefinition.RESTRICTED]: {
    [defaultChatUiDefinition.INPUT]: false,
    [defaultChatUiDefinition.RELATED_QUESTIONS]: false,
    [defaultChatUiDefinition.BOTTOM_SUGGESTIONS]: false,
    bannerText: "Some features are temporarily limited. Live device questions still work; product Q&A may be slower."
  },
  [defaultServiceStatusDefinition.PAUSED]: {
    [defaultChatUiDefinition.INPUT]: true,
    [defaultChatUiDefinition.RELATED_QUESTIONS]: true,
    [defaultChatUiDefinition.BOTTOM_SUGGESTIONS]: true,
    bannerText: "The chatbot is paused while we investigate. Please use the dashboard directly."
  },
  [defaultServiceStatusDefinition.QUOTA_EXCEEDED]: {
    [defaultChatUiDefinition.INPUT]: true,
    [defaultChatUiDefinition.RELATED_QUESTIONS]: false,
    [defaultChatUiDefinition.BOTTOM_SUGGESTIONS]: false,
    bannerText: "" // 暫時留空，目前尚未規劃要顯示上方message box.
  }
};

export const defaultChatTypesDefinition = {
  GREETING: "GREETING",
  QUICK_REPLY: "QUICK_REPLY",
  USER_INPUT: "USER_INPUT"
}

export const EXCLUDE_PATHS = ["/login", "/signup", "/forget-password", "/ws-debugger", "/surveillance"];